<template>
  <div
    class="test-status"
    :style="{
      'background-color': statusTypes[status].colorFaded,
      color: statusTypes[status].color
    }"
  >
    {{ statusTypes[status].title }}
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  props: {
    status: {
      type: String
    }
  },
  computed: {
    ...mapState("TestsStore", ["statusTypes"])
  }
};
</script>

<style lang="less" scoped>
@import "../styles/vars";

.test-status {
  display: block;
  width: fit-content;
  padding: 0 @hh;
  margin: 0;
  font-size: 0.8rem;
  text-transform: uppercase;
}
</style>
